import { buildUrlGetActionPlanApi } from 'routes/api';
import type { TypeActionPlanAPIResponse } from 'types/api';
import { NoScenario } from 'types/scenario';
import { useReader } from '../useReader';
import useData from '../useData';

export const useActionPlan = () => {
    const { currentScenario, currentCountry, currentUnit, currentUnitType } = useData();

    return useReader<TypeActionPlanAPIResponse>(
        {
            url: buildUrlGetActionPlanApi(currentScenario?.id ?? NoScenario, currentCountry ?? '', currentUnit ?? '', currentUnitType ?? ''),
            isSuspended: !currentScenario,
        }
    );
};
